module.exports = __webpack_public_path__ + "static/dumbell-78baad84e352488800c7702e339a253d.png";